module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-right-dots-66982b3c.svg";